import React from 'react';
import { MdLocationOn } from 'react-icons/md';
import { IoIosMail } from 'react-icons/io';
import { MdOutlinePhonelinkRing } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import ActionButton from 'components/ui/buttons/action-button';
import { useAppDispatch, useAppSelector } from 'reduxStore/hooks';
import { setDisplayComplainsModal, setDisplayModal } from 'reduxStore/slices/contact.slice';

export default function ContactInfo() {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    return (
        <div className="nv__contact__form__block nv__contact__form__block--info">
            <div className="contact__data">
                <div className="contact__data__container">
                    <div className="contact__data__icon">
                        <MdLocationOn />
                    </div>
                    <div className="contact__data__text">
                        <p>
                            <strong>{t('contactForm.address')}</strong>
                        </p>
                        <p>AEE - {t('panama')} Bldg. 3855 #203- 204</p>
                        <p>{t('contactForm.country')}</p>
                    </div>
                </div>
            </div>

            <div className="contact__data">
                <div className="contact__data__container">
                    <div className="contact__data__icon">
                        <MdOutlinePhonelinkRing />
                    </div>
                    <div className="contact__data__text">
                        <p>
                            <strong>{t('contactForm.phone')}</strong>
                        </p>
                        <p>+507 8387475</p>
                    </div>
                </div>
            </div>

            {/* <div className="contact__data">
                <div className="contact__data__container">
                    <div className="contact__data__icon">
                        <MdLocationOn />
                    </div>
                    <div className="contact__data__text">
                        <p>
                            <strong>{t('contactForm.address')}</strong>
                        </p>
                        <p>San Francisco</p>
                        <p> PH Midtown - 1405</p>
                        <p>{t('contactForm.country')}</p>
                    </div>
                </div>
            </div> */}

            <div className="contact__data">
                <div className="contact__data__container">
                    <div className="contact__data__icon">
                        <IoIosMail />
                    </div>
                    <div className="contact__data__text">
                        <p>
                            <strong>
                                {' '}
                                <strong>{t('contactForm.email')}</strong>
                            </strong>
                        </p>
                        <p>info@ptymgmt.com</p>
                    </div>
                </div>
            </div>

            {/* <div className="contact__data">
                <div className="contact__data__container">
                    <div className="contact__data__text">
                        <ActionButton
                            text={t('contactForm.complains')}
                            type="rounded color"
                            onClick={() => {
                                dispatch(setDisplayComplainsModal(true));
                                dispatch(setDisplayModal(false));
                            }}
                        />
                    </div>
                </div>
            </div> */}
        </div>
    );
}
